var render = function (_h,_vm) {var _c=_vm._c;return _c('hr',{class:[_vm.data.staticClass, _vm.data.class, _vm.$style.divider]})}
var staticRenderFns = []

export { render, staticRenderFns }